/**
 * @generated SignedSource<<979eca5c742be610007fc72de2bcae33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type companiesToBeDeleted_viewer$data = {
  readonly id: string;
  readonly actualPersonId: string | null;
  readonly missionControlData: {
    readonly id: string;
    readonly companiesToBeDeleted: ReadonlyArray<{
      readonly id: string;
      readonly companyId: number | null;
      readonly createdAt: string | null;
      readonly updatedAt: string | null;
      readonly name: string | null;
      readonly trialEndDate: string | null;
      readonly lastSessionDate: string | null;
      readonly projectCount: number | null;
      readonly userCount: number | null;
      readonly flaggedForDeletionDate: string | null;
      readonly domains: string | null;
      readonly toBeDeleted: boolean | null;
      readonly sisenseUserCount: number | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "companiesToBeDeleted_viewer";
};
export type companiesToBeDeleted_viewer$key = {
  readonly " $data"?: companiesToBeDeleted_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"companiesToBeDeleted_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "companiesToBeDeleted_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlCompanyToBeDeletedType",
          "kind": "LinkedField",
          "name": "companiesToBeDeleted",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "trialEndDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastSessionDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "flaggedForDeletionDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "domains",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "toBeDeleted",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sisenseUserCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "9e12e81a8816dd77733c1c4620c498b6";

export default node;
